module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAJFBMVEX/////AAAAAP9YWP9VAKr/////AAD/////AAAAAP9YWP9VAKo2nORAAAAAB3RSTlPy8vLy8uXlpW0SSwAAAFFJREFUSMdjCGAgEbAylJMMGNhJ1VEwqmVUy6iW4aDFahWJYDGD5kwSwaRRLaNaRrWMUC3eu0kEWxgkOkgEjaNaRrWMahkOWjpIBgyJgiQCMQA0NbY4NgXwIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/language/ru.png
// module id = 499
// module chunks = 0